
module.exports = {
   init: async function(parent,settings){
     this._parent=parent;
     this._settings=settings;
     this.grid_layout_end = 0;
   },
   pre_render: async function(DATA){
     this.data_length = DATA.length;
   },
   render: async function(LIST_POSITION,CURRENT_DATA,ITEM,ITEM_SETTINGS) {

      let _this = this._parent;
      _this.classList.add('list-view');
      let grid_size = 0;
      let service = _this.dsbClient.content.default_service;

      if("no-results" == CURRENT_DATA.type)
      {
        if(!isNaN(ITEM_SETTINGS) && ITEM_SETTINGS)
        {
          let noresults_component = document.createElement("dsb-post");
          noresults_component.setDSBClient(_this.dsbClient);
          noresults_component.setAttribute(`service`, 'static');
          noresults_component.setAttribute('post_id', ITEM_SETTINGS);
          noresults_component.setAttribute(`settings`, JSON.stringify({'base_update':'off','header':'off','clean_body':'on','page_view_onload':'off','pulldown_refresh':'off','lazy_images':'off','toolbar':'off'}));
          noresults_component.innerHTML = `<maa-spinner></maa-spinner>`;
          ITEM.append(noresults_component);
        }
        else
        {
          let card_element = document.createElement("div");
          let item_title = document.createElement("h2");

          let item_icon = document.createElement("div");
          item_icon.style="display:block;text-align:center;font-size:200px;height:200px;";
          if('font-icon' in ITEM_SETTINGS)
          {
            item_icon.classList.add(ITEM_SETTINGS['font-icon']);
          }
          else
          {
            item_icon.classList.add("icon-schedule");
          }
          card_element.append(item_icon);

          let item_title_text = document.createElement("span");
          item_title_text.style='display:block;';
          if('title' in ITEM_SETTINGS)
          {
            item_title_text.innerHTML = ITEM_SETTINGS['title'];
          }
          else
          {
            item_title_text.innerHTML = 'No results';
          }
          item_title.append(item_title_text);

          if('message' in ITEM_SETTINGS)
          {
            let item_title_message = document.createElement("span");
            item_title_message.style='display:block;font-size:10px;color:var(--fwwb-body-colour-font-disabled);text-align:left;';
            item_title_message.innerHTML = ITEM_SETTINGS['message'];
            item_title.append(item_title_message);
          }

          item_title.style.width="100%";
          item_title.style.textAlign="center";
          card_element.id='card_noresults';
          card_element.append(item_title);
          ITEM.append(card_element);
        }
      }
      else
      {

        ITEM.classList.add('item');

        if(`swipe_interaction` in ITEM_SETTINGS)
        {
          if(`right` in ITEM_SETTINGS.swipe_interaction)
          {
            switch(ITEM_SETTINGS.swipe_interaction.right)
            {
              case "readlater_remove":
                window.dispatchEvent(new CustomEvent('fw-workspace-add_swipe_interaction', {detail: {iam:ITEM, right:{'message':'Remove','font-icon':'icon-remove-circle'} }}));
                break;
              default:
                break;
            }
          }

        }

        if(`layout-grid` in ITEM_SETTINGS)
        {
            grid_size = ITEM_SETTINGS[`layout-grid`];

            if(this.grid_layout_end==0)
            {
              this.grid_layout_end=grid_size
            }

            this.grid_layout_end--;

            if(this.grid_layout_end<1 || LIST_POSITION == this.data_length)
            {
              ITEM.classList.add('layout-grid-row-end');
              this.grid_layout_end=0;
            }

            switch(grid_size)
            {
                case "2":
                        ITEM.classList.add('layout-grid-2');
                        break;
                case "3":
                        ITEM.classList.add('layout-grid-3');
                        break;
                case "4":
                        ITEM.classList.add('layout-grid-4');
                        break;
                case "5":
                        ITEM.classList.add('layout-grid-5');
                        break;
                case "6":
                        ITEM.classList.add('layout-grid-6');
                        break;
                default:
                    break;
            }

        }

        switch(CURRENT_DATA.type)
        {
          case "collection":
                ITEM.onclick = function(){
                  let component = document.createElement("dsb-reader");
                  component.setDSBClient(_this.dsbClient);
                  component.setAttribute(`service`, `post`);
                  component.setAttribute('collection_id', CURRENT_DATA.id);
                  component.innerHTML = `<maa-spinner></maa-spinner>`;
                  window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component}}));
                }
                break;
          default:
                ITEM.onclick = function(){
                    let component = document.createElement("dsb-post");
                    component.setDSBClient(_this.dsbClient);
                    component._navigationHandler = function(direction){
                      return function__navigateItems(direction,i);
                    };
                    component.setAttribute(`service`, service);
                    component.setAttribute('post_id', CURRENT_DATA.id);
                    let component_settings={'clean_body':'on','pulldown_refresh':'off','toolbar':{'target':'header'}};
                    if(('post' in ITEM_SETTINGS) && typeof ITEM_SETTINGS['post']=='object' && ITEM_SETTINGS['post']!=null)
                    {
                      for(let an_item_settings in ITEM_SETTINGS['post'])
                      {
                        component_settings[an_item_settings]=ITEM_SETTINGS['post'][an_item_settings];
                      }
                    }
                    component.setAttribute(`settings`, JSON.stringify(component_settings));
                    component.onEvent('readLater.toggle', function(action){
                      if(action=='removed')
                      {
                        ITEM.remove();
                      }
                    });
                    component.innerHTML = `<maa-spinner></maa-spinner>`;
                    window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component,template:'two_tray',hide:['refresh','feedback']}}));
                    //window.location.hash = "/single/post/"+CURRENT_DATA.type+"/"+CURRENT_DATA.id;
                    return;
                };
                break;
        }


        if('author' in CURRENT_DATA)
        {
          if('type' in CURRENT_DATA.author)
          {
            switch(CURRENT_DATA.author.type)
            {
              case "advert":
                  ITEM.classList.add('author-advert');
                  break;
              default:
                  break
            }
          }
        }

        if(`show-thumbnail` in ITEM_SETTINGS)
        {

            let item_image = document.createElement("span");
            item_image.classList.add('thumbnail');
            let attach_to_item = false;
            let image_size = "medium";
            let _post_image = this._settings.default_image;
            switch(ITEM_SETTINGS['show-thumbnail'])
            {
                case "right":
                    ITEM.classList.add(`layout-image-right`);
                    break;
                case "top":
                    ITEM.classList.add(`layout-image-top`);
                    image_size = "medium";
                    if(grid_size && grid_size<5)
                    {
                        image_size = "large";
                    }
                    break;
                case "left":
                    ITEM.classList.add(`layout-image-left`);
                    break;
                case "bottom":
                    ITEM.classList.add(`layout-image-bottom`);
                    image_size = "medium";
                    if(grid_size && grid_size<5)
                    {
                        image_size = "large";
                    }
                    break;
                case "background":
                    ITEM.classList.add(`layout-image-background`);
                    image_size = "large";
                    attach_to_item=true;
                    break;
                default:
                    break;

            }

            if('images' in CURRENT_DATA && typeof CURRENT_DATA.images === 'object')
            {
              if(image_size in CURRENT_DATA.images)
              {
                  _post_image = CURRENT_DATA.images[image_size];
              }
            }

            if(!attach_to_item)
            {
                item_image.setAttribute('data-img', _post_image);
                this._settings.imageObserver.observe(item_image);
                this._parent.registeredListners.push({'type':'IntersectionObserver','object':item_image});
            }
            else
            {
                ITEM.setAttribute('data-img', _post_image);
                this._settings.imageObserver.observe(ITEM);
                this._parent.registeredListners.push({'type':'IntersectionObserver','object':ITEM});
            }
            ITEM.append(item_image);

        }

        let item_title = document.createElement("h2");
        if('title' in CURRENT_DATA)
        {
          item_title.innerHTML = CURRENT_DATA.title;
          if('generated::expiration' in CURRENT_DATA)
          {
            let item_exp = document.createElement("span");
            item_exp.classList='m-icon-clock';
            let exp_text='unknown';
            if(CURRENT_DATA['generated::expiration'].days<=1)
            {
              item_exp.style="color:red;";
              exp_text='Expiring TODAY';
            }
            else if(CURRENT_DATA['generated::expiration'].days<3)
            {
              item_exp.style="color:red;";
              exp_text='Expiring in '+CURRENT_DATA['generated::expiration'].days+' days';
            }
            else if(CURRENT_DATA['generated::expiration'].days<7)
            {
              item_exp.style="color:orange;";
              exp_text='Expiring in '+CURRENT_DATA['generated::expiration'].days+' days';
            }
            else
            {
              exp_text='Expiring in '+CURRENT_DATA['generated::expiration'].days+' days';
            }

            item_exp.innerHTML=exp_text;
            item_title.append(item_exp);
          }
          ITEM.append(item_title);
        }
        else
        {
          console.error('Unknown title');
        }


        if(`show-excerpt` in ITEM_SETTINGS && (ITEM_SETTINGS[`show-excerpt`] == "true"))
        {
            if('excerpt' in CURRENT_DATA)
            {
                let item_excerpt = document.createElement("p");
                item_excerpt.innerHTML = CURRENT_DATA.excerpt;
                ITEM.append(item_excerpt);
            }
        }

        if('taxonomies' in CURRENT_DATA)
        {
          if('category' in CURRENT_DATA.taxonomies)
          {
            if(`show_all-categories` in ITEM_SETTINGS)
            {
                if('list' in CURRENT_DATA.taxonomies.category)
                {
                    let item_metadata = document.createElement("ul");
                    for(let ii = 0; ii < CURRENT_DATA.taxonomies.category.list.length; ii++)
                    {
                        let item_metadata_li = document.createElement("li");
                        item_metadata_li.innerHTML = await _this.dsbClient.content.applyFilter(`formatData_lookup`, [ `primary_cat_slug`, CURRENT_DATA.taxonomies.category.list[ii] ] );
                        item_metadata.append(item_metadata_li);
                    }
                    ITEM.append(item_metadata);
                }
            }
            else
            {
                if('primary_id' in CURRENT_DATA.taxonomies.category)
                {
                    let item_metadata = document.createElement("ul");
                    let item_metadata_li = document.createElement("li");
                    let this_tax = await _this.dsbClient.content.applyFilter(`formatData_lookup`, [ `all_cat_obj`, CURRENT_DATA.taxonomies.category.primary_id ]);
                    if(typeof this_tax === 'object' && `root_parent` in this_tax)
                    {
                      this_tax = _this.dsbClient.content.applyFilter(`formatData_lookup`, [ `all_cat_obj`, this_tax.root_parent ]);
                    }
                    item_metadata_li.innerHTML = this_tax.name;
                    item_metadata.append(item_metadata_li);
                    ITEM.append(item_metadata);
                    if(ITEM.classList.contains(`layout-image-background`))
                    {
                      item_metadata_li.classList.add(this_tax.slug+'-category-bg-color');
                      item_metadata_li.style.padding="10px";
                      item_metadata_li.style.lineHeight="5px";
                    }
                    else
                    {
                      item_metadata_li.classList.add(this_tax.slug+'-category-font-col');
                    }

                }
            }
          }
        }
      }
   }
}
